import { v4 as uuidv4 } from 'uuid';

export const getUserId = (): string => {
  let userId = localStorage.getItem('user_uuid');

  if (!userId) {
    userId = uuidv4();
    localStorage.setItem('user_uuid', userId);
  }

  return userId;
};
